import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'ng-connection-service';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityMonitorService {
  private destroyRef = inject(DestroyRef);
  private connectionService = inject(ConnectionService);
  private toast = inject(ToastrService);
  private isConnected$ = new BehaviorSubject<boolean>(navigator.onLine);
  private isOffline = false;

  constructor() {
    this.connectionService.monitor().pipe(
      debounceTime(500),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((isConnected) => {
      this.isConnected$.next(isConnected.hasNetworkConnection);
      this.handleConnectionToast(isConnected.hasNetworkConnection);
    });
  }

  public get connectionStatus$(): Observable<boolean> {
    return this.isConnected$.asObservable();
  }

  public get isConnected(): boolean {
    return this.isConnected$.value;
  }

  private handleConnectionToast(isConnected: boolean) {
    if (isConnected && this.isOffline) {
      this.toast.clear();
      this.toast.success('You are back online!', '', {
        timeOut: 6000,
        positionClass: 'toast-top-right',
        easing: 'ease-in-out',
        closeButton: true,
        toastClass: 'ngx-toastr custom-toastr',
      });
      this.isOffline = false;
    } else if (!isConnected && !this.isOffline) {
      this.toast.error('You are offline!', '', {
        disableTimeOut: true,
        positionClass: 'toast-top-right',
        easing: 'ease-in-out',
        closeButton: true,
        toastClass: 'ngx-toastr custom-toastr',
      });
      this.isOffline = true;
    }
  }
}
